module.exports = __webpack_public_path__ + "static/img/union.8dcd0ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/mo/zh/union.png
// module id = DZuV
// module chunks = 1 3